import { useEffect, useState, RefObject } from "react";
import { throttle } from "@/utils/throttle";

interface useCanvasSizeProps {
  canvasRef: RefObject<HTMLCanvasElement | null>;
  defaultSize: { width: number; height: number };
}

export const useCanvasReSize = ({
  canvasRef,
  defaultSize,
}: useCanvasSizeProps) => {
  const [canvasSize, setCanvasSize] = useState(defaultSize);

  useEffect(() => {
    const updateCanvasSize = () => {
      //장치 pixel 비율
      const pixelRatio = window.devicePixelRatio || 1;

      const cssWidth = window.innerWidth < 768 ? 360 : 708;
      const cssHeight = window.innerWidth < 768 ? 318 : 800;

      setCanvasSize({ width: cssWidth, height: cssHeight });

      if (canvasRef.current) {
        //캔버스 해상도 스타일 설정
        canvasRef.current.width = cssWidth * pixelRatio;
        canvasRef.current.height = cssHeight * pixelRatio;
        canvasRef.current.style.width = `${cssWidth}px`;
        canvasRef.current.style.height = `${cssHeight}px`;

        const ctx = canvasRef.current.getContext("2d");
        if (ctx) {
          ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        }
      }
    };

    const throttledUpdate = throttle(updateCanvasSize, 100);

    if (typeof window !== "undefined") {
      updateCanvasSize();
      window.addEventListener("resize", throttledUpdate);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", throttledUpdate);
      }
    };
  }, [canvasRef]);

  return canvasSize;
};
